"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseHtml = parseHtml;
exports.serializeHtml = serializeHtml;
exports.applyDomFilters = applyDomFilters;
exports.getHtmlTransforms = getHtmlTransforms;
exports.addPreProcessTransform = addPreProcessTransform;
exports.addPostProcessTransform = addPostProcessTransform;
exports.getRemoveTransformsHandler = getRemoveTransformsHandler;
exports.replaceNodes = void 0;
var activeTransforms = {};

function parseHtml(html) {
  var parser = new DOMParser();
  var doc = parser.parseFromString("<html><body>" + html + "</body></html>", 'text/html');
  return doc;
}

function serializeHtml(doc) {
  if (!doc.body) {
    return '';
  }

  return doc.body.innerHTML;
}

function applyDomFilters(html, filters) {
  var doc = parseHtml(html);

  if (!doc.body) {
    return '';
  }

  filters.forEach(function (filter) {
    filter(doc);
  });
  return serializeHtml(doc);
}

function getHtmlTransforms(editor) {
  if (!activeTransforms[editor.id]) {
    activeTransforms[editor.id] = {
      preProcess: [],
      postProcess: []
    };
  }

  return activeTransforms[editor.id];
}

function addPreProcessTransform(editor, transform) {
  var transforms = getHtmlTransforms(editor);
  transforms.preProcess.push(transform);
}

function addPostProcessTransform(editor, transform) {
  var transforms = getHtmlTransforms(editor);
  transforms.postProcess.push(transform);
}

var replaceNodes = function replaceNodes(nodes, replaceNode) {
  var nodesArr = Array.from(nodes);
  nodesArr.forEach(function (node) {
    if (node.parentNode) {
      var replacementNodes = replaceNode(node);

      if (replacementNodes instanceof NodeList) {
        Array.from(replacementNodes).forEach(function (childNode) {
          node.parentNode.insertBefore(childNode, node);
        });
        node.parentNode.removeChild(node);
      } else {
        node.parentNode.replaceChild(replacementNodes, node);
      }
    }
  });
};

exports.replaceNodes = replaceNodes;

function getRemoveTransformsHandler(editor) {
  return function () {
    activeTransforms[editor.id] = null;
  };
}